import PropTypes from "prop-types"
import { get } from "lodash"
import classNames from "classnames"
import { StarRounded } from "@mui/icons-material"
import { TableRow, TableCell } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { numberFormatter } from "helpers/formatters/numbers"
import { getDriftType } from "helpers/drift"
import Drift from "components/drift/drift"

function DetailRow({ value }) {
  return <TableRow className={classNames("detail-row", { favorite: value.favorite })}>
    <TableCell className="name" component="th" scope="row">
      <div className="factor-link-wrapper">
        <StarRounded className="star-icon" />
        <span>{value.label}{!!value.secondaryLabel && <span className="secondary">&nbsp;- {value.secondaryLabel}</span>}</span>
      </div>
    </TableCell>
    <TableCell align="right">
      <Tooltip classes={{ popper: "security-profile-drift", tooltip: "drift-tooltip" }} title={`Exposure drift for ${value.label} is ${get(getDriftType(value.drift), "label")}`}>
        <div className="factor-value-wrapper">
          <Drift drift={value.drift} />
          {numberFormatter(value.value)}
        </div>
      </Tooltip>
    </TableCell>
  </TableRow>
}

DetailRow.propTypes = {
  value: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
}

export default DetailRow
